import React from "react";
import ReusablePDFLayout from "../ReusablePDFLayout";

export const Page3 = (salaryType) => {
  return (
    <ReusablePDFLayout>
      <div className="parentcls">
        {salaryType === "TYPE_ONE" && (
        <p className="para" style={{ margin: "15px 0" }}>
          You will also be covered under the Group Gratuity Scheme of the
          Company. The offered salary also includes communication/internet
          charges incurred during the course of your work for the organization
          and there would be no separate reimbursement for the same. Further,
          the Company as part of the conditions of service- employment, on the
          request of the employee, grants necessary loans, on a case to case
          basis subject to execution of necessary agreements.
        </p>
        )}
        <p className="bolds" style={{ margin: "15px 0" }}>
          Insurance:
        </p>
        <p className="para">
          <span >
            {" "}
            Medical Benefits{" "}
          </span>{" "}
          - You, your spouse, dependent children will be covered at company’ s
          cost under the Mediclaim Insurance policy/ESI, as applicable and
          eligible.
        </p>
        <p className="bolds" style={{ margin: "15px 0" }}>
          Leave:
        </p>
        <p className="para">
          {/* Other than the Annual Holidays declared by the Company every calendar
          year, on confirmation of your employment with Company, you are
          entitled to avail the below Leave with the Leave Policy of the
          Company. */}
          Leave and other benefits will be provided in accordance with the Company’s policies and applicable statutory regulations. 
        </p>
        {/* <p className="para">Flexi leaves of 24 days.</p>
        <p className="para">Privilege Leave of 12 days.</p>
        <p className="para">
          You shall be eligible for Leaves including but not limited to
          Maternity or Paternity Leave and related benefits, as per the Leave
          Policy laid down by Company.
        </p>
        <p className="para">
          The Leave policy of the Company is subject to change at any time with
          or without prior notice and the amended Leave policy shall replace the
          then existing Leave policy which shall be binding on you.
        </p> */}
        <p className="bolds" style={{ margin: "15px 0" }}>
          Hours of work:
        </p>
        <p className="para">
          Working hours shall be as per the Company’s policy. Hours may vary depending on role requirements, and additional
           hours may be necessary to ensure proper discharge of responsibilities. 
          {/* The Company’s core hours of operation are from Monday to Friday from
          <span className="bols"> 9.30 am </span>
          to <span className="bols"> 05:30 pm </span> . You are expected to work
          a minimum of{" "}
          <span className="bols" >
            {" "}
            08{" "}
          </span>{" "}
          hours per day. You will be required to work for such hours as
          necessary for the proper discharge of your duties to the Company and
          you are expected to work not less than the prescribed hours each day
          and if necessary for additional hours depending on your
          responsibilities. */}
        </p>
        <p className="bolds" style={{ margin: "15px 0" }}>
          Conflict of Interest:
        </p>
        <p className="para">
          While employed by the Company, you agree to work on a full-time basis
          exclusively for the Company and agree that you shall not, while you
          are employed by the Company, be employed or engaged in any capacity,
          in promoting, undertaking or carrying on any other business that
          competes with the Company or interferes or could reasonably interfere
          with your duties to the Company without our prior written permission.
        </p>
      </div>
    </ReusablePDFLayout>
  );
};
